import type { WidgetPreset } from "../types";
import { FONT } from "../types";
import templateHtml from "./template.html?raw";

export const CAUTION_ZONE: WidgetPreset = {
  id: "caution-zone",
  label: "Caution Zone",
  defaultWidth: 240,
  defaultHeight: 48,
  html: templateHtml.replaceAll("__FONT__", FONT),
};
